import { FulfillmentGroupColumnKey } from "@redotech/redo-fulfillment-common/fulfillment-group-column-keys";
import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import {
  getTotalCostCell,
  getTotalCostExpandedCell,
  getUnitCostCell,
  getUnitCostExpandedCell,
} from "@redotech/redo-fulfillment-operations-common/csv-columns/unit-cost-csv";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";

const unitCostEntry = fgColumnEntries[FulfillmentGroupColumnKey.UNIT_COST];

export const UnitCostColumn: Column2<FulfillmentGroupData> = {
  key: unitCostEntry.key,
  title: unitCostEntry.title,
  renderNormalCell: ({ row }) => (
    <RedoTableTextCell text={getUnitCostCell(row)} />
  ),
  renderExpandedCell: ({
    row,
    expansionIndex,
  }: {
    row: FulfillmentGroupData;
    expansionIndex: number;
  }) => (
    <RedoTableTextCell text={getUnitCostExpandedCell(row, expansionIndex)} />
  ),
  width: unitCostEntry.defaultWidth,
  alignment: ColumnAlignment.LEFT,
  sort: unitCostEntry.sortDirection,
};

const totalCostEntry = fgColumnEntries[FulfillmentGroupColumnKey.TOTAL_COST];

export const TotalCostColumn: Column2<FulfillmentGroupData> = {
  key: totalCostEntry.key,
  title: totalCostEntry.title,
  renderNormalCell: ({ row }) => (
    <RedoTableTextCell text={getTotalCostCell(row)} />
  ),
  renderExpandedCell: ({
    row,
    expansionIndex,
  }: {
    row: FulfillmentGroupData;
    expansionIndex: number;
  }) => (
    <RedoTableTextCell text={getTotalCostExpandedCell(row, expansionIndex)} />
  ),
  width: totalCostEntry.defaultWidth,
  alignment: ColumnAlignment.LEFT,
  sort: totalCostEntry.sortDirection,
};
